export default __webpack_public_path__ + "static/MonitorSection_es-8cb4c847855236a67e110fa8716cf445.png";